"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bc47_module = require('bcp-47');
const bcp47_parse = bc47_module.parse;
exports.parse = bcp47_parse;
const bcp47_stringify = bc47_module.stringify;
exports.stringify = bcp47_stringify;
exports.format = bcp47_stringify;
const bc47_normalize_module = require('bcp-47-normalize');
const bcp47_normalize = bc47_normalize_module;
exports.normalize = bcp47_normalize;
//# sourceMappingURL=index.js.map